module.exports = __webpack_public_path__ + "static/media/fire-joypixels.e8ec6e01.gif";